var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"name":`field_${_vm._uid}`,"rules":_vm.rules,"custom-messages":{
    required: _vm.$t('validation.namedFieldIsMandatory', {
      field: _vm.localize(this.item.label)
    })
  },"mode":"eager"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-text-field',{attrs:{"outlined":"","flat":"","hide-details":"auto","label":_vm.fieldLabel,"name":_vm.fieldLabel,"error-messages":errors,"autocomplete":_vm.autofill},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }